import { FC } from 'react';
import { isMobile } from 'react-device-detect';

import Box from '../v2/components/Box';
import Flex from '../v2/components/Flex';

// Local Typings
interface Props {
  leftButton: React.ReactElement<HTMLButtonElement>;
  rightButton: React.ReactElement<HTMLButtonElement>;
}

// Component Definition
const ButtonPair: FC<Props> = props => {
  const insideMargin = isMobile ? undefined : 4;
  const marginY = isMobile ? 2 : 4;

  return (
    <Flex
      flexDirection={isMobile ? 'column' : 'row'}
      fullWidth={isMobile}
      justifyContent="center"
    >
      <Box
        marginRight={insideMargin}
        marginY={marginY}
      >
        {props.leftButton}
      </Box>
      <Box
        marginLeft={insideMargin}
        marginY={marginY}
      >
        {props.rightButton}
      </Box>
    </Flex>
  );
};

export default ButtonPair;
